<template>
  <div>
    <div id="container">
      <div class="lu_toper">
        <div class="lu_top">欢迎使用{{payMethod}}付款</div>
      </div>
      <div>
        <div class="lu_login">
          <div class="lu_log">
            <img src="../../.././assets/img/login.jpg" />
          </div>
        </div>
        <div class="lu_main">
          <div class="lu_maintop">
            <p>正在使用即时到账交易<span style="color: #3cb034">[?]</span></p>
            <div>
              <div class="fl">
                <b id="suit_type"></b
                ><span style="margin-left: 10px; font-size: 12px"
                  >收款方：广州市小弹壳网络科技有限公司</span
                >
              </div>
              <div class="fr jaige" :style="{color:payMethod=='支付宝'?'#0d9fff':'3cb034'}">
                <!-- <span id="total">{{ payMoney }}</span>元 -->
                <span id="total" :style="{color:payMethod=='支付宝'?'#0d9fff':'3cb034'}">{{payMoney}}</span>元
              </div>
              <div class="clear"></div>
              <input type="hidden" id="orderid" value="" />
            </div>
          </div>
          <div class="lu_mianer">
            <div class="contentBox">
              <div class="leftBox">
                <img :src="payImg" alt="" style="width: 170px; height: 170px" />
                <div class="bottom">
                  <img class='sao' src="/assets/img/sao.jpg" alt="">
                  <p>打开手机{{payMethod}}<br>扫一扫继续付款</p>
                </div>
                <p class='title'>首次使用请下载手机{{payMethod}}</p>
              </div>
              <img class='weixin' src="../../.././assets/img/weixn.png">
            </div>
          </div>
        </div>
        <div class="banquan">
          © 1998 - 2018 Tencent Inc. All Rights Reserved
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doPost from "@/pages/Helper/XHR.js";
export default {
  name: "Weixin_pay",
  data() {
    return {
      payImg: "",
      payMoney: "",
      timer: null,
      payMethod:'微信'
    };
  },
  mounted() {
    console.log(this.$router.history.current.params);
    if (this.$router.history.current.query) {
      this.payImg = this.$router.history.current.params.code_url;
      this.payMoney = this.$router.history.current.params.money;
      this.payMethod = this.$router.history.current.params.payMethod == 'alipay' ? '支付宝' : '微信';
      let orderid = this.$router.history.current.params.orderid;
      // this.payOrderid(orderid);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null
    }
  },
  methods: {
    payOrderid(orderid) {
      console.log('订单id',orderid)
      if (orderid) {
        if(this.timer){
          clearInterval(this.timer);
          this.timer = null
        }
        this.timer = setInterval(() => {
          doPost({ action: "orderquery", orderid: orderid }, (res) => {
            if (res.detail == '支付成功' && res.status == 0) {
              console.log('清掉定时器')
              clearInterval(this.timer);
              this.timer = null
              this.$Message.success("您已支付成功");
              this.$router.push("/Personal");
            }else{
              if(res.detail == '支付失败' && res.status == 1){
                this.payOrderid(orderid)
              }
            }
          });
        }, 1500);
      }
    },
  },
  created(){
    console.log(this.$store.state.orderId);
    if(this.$store.state.orderId){
        this.orderid = this.$store.state.orderId
        localStorage.setItem('orderId',this.orderid)
    }else{
      this.orderid = localStorage.getItem('orderId')
    }
    doPost({action: 'pay', orderid: this.orderid, int: '', dev: 'pc'},
      (res) => {
          console.log(res);
          this.payImg = res.code_url;
          this.payMoney =res.money;
          let orderid = res.orderid
          this.payOrderid(orderid);
    })
  },
};
</script>


<style>
.lu_toper {
  width: 100%;
  height: 25px;
  line-height: 25px;
  background: #81878b;
  text-align: right;
  color: #fff;
}

.lu_top {
  width: 950px;
  margin: 0 auto;
  font-size: 12px;
}

.lu_login {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #ccc;
  min-height: 60px;
}

.lu_log {
  width: 950px;
  margin: 0 auto;
  padding-top: 10px;
}

.lu_main {
  width: 950px;
  margin: 0 auto;
  min-height: 500px;
  border-radius: 5px;
  margin-top: 30px;
}

.lu_maintop {
  width: 100%;
  /* min-width: 400px; */
}

.a {
  display: block;
}

.b {
  display: none;
}

.lu_main {
  font-size: 14px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clear {
  clear: both;
}

.jaige {
  font-size: 30px;
  color: #3cb034;
  font-weight: 600;
  font-family: "微软雅黑";
  margin-top: -20px;
}

.lu_mianer {
  width: 100%;
  min-height: 600px;
  background: #fff;
  border-radius: 1px;
  border-top: 3px solid #ccc;
  border-bottom: 3px solid #ccc;
  margin-top: 10px;
  position: relative;
}
.banquan {
  width: 100%;
  text-align: center;
  font-size: 12px;
  margin-top: 20px;
  color: #808080;
}

.contentBox {
  position: absolute;
  background-color: #fff;
  padding: 10px;
  left: 50%;
  top: 50%;
  transform: translate(-40%,-50%);
}
.contentBox .leftBox {
  /* width: 200px; */
  display: inline-block;
  padding: 10px;
  box-shadow: 0 0 5px #ccc;
}
.contentBox .bottom .sao,.contentBox .bottom p {
  display: inline-block;
  line-height: 22px;
  text-align: center;
}
.contentBox .bottom .sao{
  margin: -16px 15px 5px;
}

.contentBox .title {
  text-decoration: underline;
  color: #666;
  font-size: 14px;
  margin: 5px auto;
  text-align: center;
}
.weixin {
  margin-top: -280px;
}

@media screen and (max-width: 768px) {
  .lu_top,
  .lu_main {
    min-width: 300px;
    width: 100%;
    padding: 0 15px;
  }
  .lu_mianer {
    min-height: 450px;
  }
  .contentBox {
    transform: translate(-50%,-50%);
  }
  .weixin {
    display: none;
  }
  .jaige {
    font-size: 14px;
    margin-top: -8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Personal/components/Weixinpay.vue